/** Limit — snap the mark to a grid, blocking it into steps. */
import type { AffectModule } from '../../core/module-api';
import { cfgNum } from '../../core/module-api';
import { cloneShape } from '../../core/scene';
import { transformPath } from '../../core/geometry';

const ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9h18"/><path d="M3 15h18"/><path d="M9 3v18"/><path d="M15 3v18"/></svg>';

export function createLimit(): AffectModule {
  return {
    manifest: {
      id: 'limit',
      kind: 'affect',
      name: 'Limit',
      apiVersion: 1,
      description: 'Snap every point to a grid — your mark goes blocky.',
      icon: ICON,
      params: [{ kind: 'slider', key: 'grid', label: 'Grid', min: 2, max: 80, step: 1, default: 16 }],
    },

    affect(shapes, ctx) {
      const step = cfgNum(ctx.config, 'grid', 16);
      if (step <= 0) return shapes.slice();
      return shapes.map((s) => {
        const c = cloneShape(s);
        c.path = transformPath(s.path, (p) => ({ x: Math.round(p.x / step) * step, y: Math.round(p.y / step) * step }));
        return c;
      });
    },
  };
}
